import { FC, ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
import VideoAuto from 'components/VideoAuto'
import Candidate from 'Types/candidate.interface'
import { device } from '../breakpoints'
import { ArticleTeaser } from 'components/articleLink'
import CopyUrl from 'components/CopyUrl'
import { IoMdArrowDroprightCircle } from 'react-icons/io'

import {
  useTransition,
  animated,
  config as springConfig,
} from '@react-spring/web'
// import { CopyToClipboardUrl } from 'components/copyToClipboardUrl'
// import { ArticleTeaser } from 'components/articleLink'
// import { VideoAuto } from 'components/videoAuto'
// import VideoPlayerContext from '../videoPlayerContext'
// import { VideoPlayerProvider } from '../videoPlayerContext'

const isMobile = window.innerWidth < 768
// const randomArticles = [
//   861373316366, 898870841121, 378340152181, 339494938235, 568086529447,
//   775895217110, 949517109675, 588148085500,
// ]
const randomArticles:any[] = []

const randomChosenArticles = (num: number) => {
  const chosenArticles = []
  const articles = [...randomArticles]

  for (let i = 0; i < num; i++) {
    const randomIndex = Math.floor(Math.random() * articles.length)
    chosenArticles.push(articles[randomIndex])
    articles.splice(randomIndex, 1)
  }

  return chosenArticles
}

type InfoLayerProps = {
  candidate: Candidate
  nextCandidate: Candidate
  handleNextCandidateClick: (candidate: Candidate) => void
  handleClose: () => void
}

const InfoLayer: FC<InfoLayerProps> = ({
  candidate,
  nextCandidate,
  handleNextCandidateClick,
  handleClose,
}): ReactElement => {
  // const location = useLocation()
  // const history = useHistory()

  const [showInfoLayer, setShowInfoLayer] = useState(true)
  const [muted, setMuted] = useState<boolean>(true)

  const handleExit = () => {
    setShowInfoLayer(false)
  }

  const transitions = useTransition(showInfoLayer, {
    config: springConfig.stiff,
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    onRest: () => {
      // if (location.pathname === '/') {
      //   document.body.classList.remove('freeze')
      // } else {
      //   document.body.classList.add('freeze')
      // }
      if (!showInfoLayer) {
        handleClose()
        document.body.style.overflow = 'auto'
        document.body.style.height = 'auto'
      }
    },
  })

  useEffect(() => {
    setShowInfoLayer(true)
    document.body.style.overflow = 'hidden'
    document.body.style.height = '100%'
  }, [candidate])

  // useEffect(() => {
  //   if (candidates) {
  //     const candidate = candidates
  //       ? candidates.find(c => c.id === location.pathname.substr(1))
  //       : null

  //     if (location.pathname === '/') {
  //       setShowInfoLayer(false)
  //     } else {
  //       setSelectedCandidate(candidate)
  //     }

  //     if (candidate) {
  //       setShowInfoLayer(true)
  //     }
  //   }
  // }, [location.pathname, candidates])

  // const nextCandidate = selectedCandidate
  //   ? candidates[
  //       (candidates.findIndex(c => c.id === selectedCandidate.id) + 1) %
  //         candidates.length
  //     ]
  //   : null

  console.log('candidate links', candidate.articlesLinks)

  return transitions(
    (styles, item) =>
      item && (
        <>
          <Dimmer
            onClick={() => {
              handleExit()
            }}
            style={styles}
          />
          {/* <animated.div
            className={stylesSheet.closeBtn}
            style={{ opacity: styles.opacity.to([0.5, 1], [0, 1]) }}
            onClick={() => {
              handleExit()
            }}
          >
            <div className='close' />
          </animated.div> */}
          <Container
            style={{
              transform: styles.opacity.to(
                (v) => 'translate3d(0,' + (1 - v) * 100 + '%,0)'
              ),
            }}
          >
            <VideoContainer>
              <Menu>
                <NextCandidatePicture
                  onClick={() => {
                    handleNextCandidateClick(nextCandidate)
                  }}
                  src={nextCandidate.photo}
                />
                <MenuInfos
                  onClick={() => {
                    handleNextCandidateClick(nextCandidate)
                  }}
                >
                  <MenuNextText>
                    {nextCandidate.genre === 'f'
                      ? 'Candidate suivante'
                      : 'Candidat suivant'}
                  </MenuNextText>
                  <MenuName>{nextCandidate.name}</MenuName>
                  <Link>
                  <span style={{marginRight: '.5em'}}>
                    Voir la vidéo</span>
                    <IoMdArrowDroprightCircle />
                  </Link>
                </MenuInfos>
                <CloseMenu
                  onClick={() => {
                    handleExit()
                  }}
                >
                  <Close />
                </CloseMenu>
              </Menu>
              <VideoAuto src={candidate.video} muted={true} />
            </VideoContainer>

            <div className='ui vertical fitted segment info-footer'>
              <Text>
                <div>
                  <Name>{candidate.name}</Name>
                  <Infos>
                    <div>
                      {candidate.age} ans, {candidate.location}
                    </div>
                    <div>{candidate.groupName}</div>
                  </Infos>
                </div>
              </Text>
            </div>

            <div
              style={{
                borderTop: '1px solid #ffffff33',
                borderBottom: '1px solid #ffffff33',
              }}
              className='ui text container'
            >
              <Text>
                <CopyUrl
                  inverted
                  locale='fr'
                  title='Partager ce contenu'
                  text='Partagez cette vidéo avec vos amis et vos connaissances!'
                  url={window.location.href}
                  buttonColor='#539ea4'
                />
              </Text>
            </div>

            {candidate.articlesLinks.length > 0 && (
              <div className='ui vertical fitted segment info-footer'>
                <Text>
                  <ArticleTeaser
                    tenant='tdg'
                    title='À lire aussi'
                    color='#539ea4'
                    ids={
                      [
                        ...randomChosenArticles(3),
                        ...candidate.articlesLinks
                          .replaceAll(' ', '')
                          .split(','),
                      ] as string[]
                    }
                  />
                </Text>
              </div>
            )}
          </Container>
        </>
      )
  )
}

const Dimmer = styled(animated.div)`
  z-index: 19;
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(10px);
`
const Container = styled(animated.div)`
  z-index: 999;
  position: fixed;
  transform: translate3d(0, 0, 0);
  bottom: 0px;
  overflow-y: scroll;
  background-color: #1b1c1d;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.085);
  border-radius: 4px 4px 0px 0px;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    width: 100%;
    margin-left: auto;
    left: 0px;
    height: 90%;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    left: 50%;
    margin-left: -400px;
    width: 800px;
    height: 90%;
  }
`
const VideoContainer = styled.div`
  top: 0;
  left: 0;
  position: relative;
  width: 100%;
  z-index: 1;
  box-shadow: 0 10px 20px #1b1c1d;
`
const Text = styled.div`
  color: #ffffffdd;
  max-width: 600px;
  margin: 2em auto;
  font-family: var(--font-sans-serif);
  padding: 0 1em;
`
const Menu = styled.div`
  height: 10vh;
  color: #ffffffdd;
  font-family: var(--font-sans-serif);
  font-size: 0.75em;
  user-select: none;
  background-color: #1b1c1d;
  position: sticky;
  transform: translate3d(0, 0, 0);
  top: 0;
  z-index: 2;

  display: flex;
  justify-content: space-around;
  align-items: stretch;
`
const NextCandidatePicture = styled.img`
  height: 100%;
  width: auto;
  margin-right: 1em;
  flex: 0 0 10vh;
  cursor: pointer;
`
const MenuInfos = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  line-height: 1.2em;
  padding-right: 1em;
  width: calc(100% - 20vh -1em);
  float: left;
  height: 100%;
  cursor: pointer;
`
const MenuName = styled.div`
  font-weight: 600;
  line-height: 1.25;
  font-size: 1.2em;
  margin-bottom: 0.25em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`

const MenuNextText = styled.div`
  font-size: 0.75em;
  opacity: 0.6;
`

const Link = styled.div`
  display: inline-flex;
  align-items: center;
  line-height: 1em;
  opacity: 0.8;
`
const CloseMenu = styled.div`
  background-color: #000000;
  margin-left: auto;
  height: 100%;
  width: 10vh;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex: 0 0 10vh;

  &:after {
    content: '';
    margin-top: 75%;
  }
`
const Close = styled.div`
  position: relative;
  display: inline-block;
  width: 32px;
  height: 32px;
  opacity: 0.75;

  &:before,
  &:after {
    left: 15px;
    position: absolute;
    content: ' ';
    height: 33px;
    width: 2px;
    background-color: #ffffff;
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
`
const Name = styled.div`
  font-weight: 600;
  line-height: 1.25;
  font-size: 1.5em;
`
const Infos = styled.div`
  margin-top: 0.25em;
  font-size: 1em;
  line-height: 1.35em;
  opacity: 0.65;
`

export default InfoLayer

// .close-btn {
//   z-index: 99;
//   position: fixed;
//   width: 60px;
//   height: 60px;
//   border-radius: 50%;
//   background-color: #282732;
//   box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.85);
//   top: calc(10% + 40px);
//   right: calc((100vw - 800px) / 2 + 40px);
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   cursor: pointer;
//   transition: opacity 0.4s ease-in;

//   @media screen and (max-width: 768px) {
//     top: 26px;
//     right: 30px;
//   }

//   &:hover {
//     .close {
//       opacity: 1;
//     }
//   }
// }
